import { IRegistryState } from '../interfaces/IRegistryState';

export const initialRegistryState: IRegistryState = {
  okved: {},
};
